<template>
  <div class="page">
    <div class="header">
      支付中遇到问题请联系客服电话：<span style="color: #E96C3D;">400-8816-822</span> 
    </div>
    <div style="display: flex;justify-content: center;">
     
        <div class="box">
           <div class="text_1">请使用支付宝扫码支付</div>
       <!-- 二维码容器 -->
    <div id="qrcode" style="margin-top: 20px"></div>
    <div class="price">
      ¥{{ ordMoneysum }}
    </div>
    <div class="text_2">
<div class="text_3">温馨提示</div>
<div class="text_4">支付完成后请不要关闭此页面，等待此页面弹出支付成功提示； 如果确实支付成功，订单却显示未支付，请联系客服</div>
    </div>
    </div> 
    </div>
 
   
  </div>
</template>

<script>
import '@/utils/qrcode.js';
import { toTradeQuery } from '@/api/pay.js';

export default {
  data() {
    return {
      text: '',
      orderInfo: {
        order: {
          id: this.$route.query.orderId||''
        }
      },
      payShow: true,
      checkInterval: null, // 定时器引用
      ordMoneysum:this.$route.query.ordMoneysum||''
    };
  },
  mounted() {
    this.text = this.$route.query.data;
    const orderId = this.$route.query.orderId;
    if (!orderId) {
      this.$message.error('缺少订单ID');
      return;
    }

    // 渲染二维码
    if (this.text) {
      this.$nextTick(() => {
        const container = document.getElementById('qrcode');
        if (container) {
          container.innerHTML = '';
          new QRCode(container, {
            text: this.text,
            width: 200,
            height: 200,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
          });
        }
      });
    }

    // 启动轮询：每 2 秒检查一次支付状态
    this.startPolling();
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    this.stopPolling();
  },
  methods: {
    startPolling() {
      this.checkInterval = setInterval(() => {
        this.toTradeQueryZFB();
      }, 2000); // 每2000毫秒（2秒）调用一次
    },
    stopPolling() {
      if (this.checkInterval) {
        clearInterval(this.checkInterval);
        this.checkInterval = null;
      }
    },
    toTradeQueryZFB() {
      const orderId = this.orderInfo.order.id;
      if (!orderId) return;

      toTradeQuery({ orderId ,ordPayType:this.$route.query.ordPayType})
        .then(res => {
          const result = res?.data?.data?.result;
          console.log('对账结果:', result);

          if (result !== '2') {
            this.stopPolling();

            this.$message({
              message: '支付成功！',
              type: 'success'
            });

            this.$router.push({
              path: '/paySuccess',
              query: {
                orderId: this.orderInfo.order.id
              }
            });
          }
        })
        .catch(err => {
          console.error('对账请求失败:', err);
        });
    }
  }
};
</script>

<style scoped>
#qrcode {
  display: inline-block;
  padding: 10px;
  background: #fff;
  border-radius: 8px;
}
.page{
  background: #F4F6FA;
  height: 100vh;
}
.header{
  width: 100%;
height: 68px;
background: #FFFFFF;
box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.04);
border-radius: 0px 0px 0px 0px;
display: flex;
justify-content: center;
align-items: center;

}
.text_1{
font-family: PingFang SC, PingFang SC;
font-weight: 600;
font-size: 24px;
color: #333333;
text-align: center;
margin-top: 50px;
}
.box{
  width: 1400px;
height: 650px;
margin-top: 12px;
background: #FFFFFF;
border-radius: 0px 0px 0px 0px;
display: flex;
align-items: center;
flex-direction: column;
}
.price{
  margin-top: 20px;
font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
font-weight: bold;
font-size: 28px;
color: #E96C3D;
}
.text_2{
  margin-top: 30px;
  width: 580px;
height: 130px;
background: #F4F6FA;
border-radius: 8px 8px 8px 8px;
padding: 20px 38px;

}
.text_3{
  font-family: PingFang SC, PingFang SC;
font-weight: 500;
font-size: 20px;
color: #333333;
text-align: center;
}
.text_4{
font-family: PingFang SC, PingFang SC;
font-weight: 400;
font-size: 18px;
color: #5B5B5B;
text-align: center;
}
</style>
